(function () {
  'use strict';

  var MUTATION = 'mutation CreateKnifeRegistration($input: CreateKnifeRegistrationInput!) { createKnifeRegistration(input: $input) { id first_name last_name email knife_photo_url } }';

  // Fields sent as plain values (files are collected separately below).
  var BOOLEAN_FIELDS = ['consent_confirmed', 'marketing_opt_in', 'is_founders_run'];
  var FILE_FIELDS = ['knife_photo', 'certificate_photo'];

  function extractGraphqlErrorMessage(error) {
    if (!error) return '';

    var extensions = error.extensions || {};
    var nested = extensions.originalError || extensions.exception || extensions.response || {};
    var detail = nested.message || extensions.message;

    if (Array.isArray(detail)) return detail.filter(Boolean).join(' ');
    if (detail) return String(detail);

    return error.message || '';
  }

  function extractToken(raw) {
    if (!raw) return '';
    var value = String(raw).trim();
    if (!value) return '';

    try {
      var parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object') {
        return extractToken(parsed.accessToken || parsed.token || parsed.authToken || parsed.jwt);
      }
    } catch (error) {
      // Stored token is already a plain string.
    }

    return value.replace(/^Bearer\s+/i, '').trim();
  }

  // Registration is public, but a logged-in customer's token is attached
  // when present so the API can associate the registration with their account.
  function getToken() {
    var authConfig = (window.TKC && window.TKC.authConfig) || {};
    var keys = Array.isArray(authConfig.tokenFallbackKeys) && authConfig.tokenFallbackKeys.length
      ? authConfig.tokenFallbackKeys
      : [authConfig.tokenKey || 'tkcAccessToken', 'tkcAccessToken', 'tkcAssesstoken', 'accessToken', 'token', 'authToken'];

    for (var i = 0; i < keys.length; i += 1) {
      var token = extractToken(window.localStorage.getItem(keys[i]));
      if (token) return token;
    }

    return '';
  }

  function collectInput(form) {
    var input = {};
    var uploads = [];

    form.querySelectorAll('[data-rk-field]').forEach(function (field) {
      var key = field.dataset.rkField;

      if (FILE_FIELDS.indexOf(key) !== -1) {
        var file = field.files && field.files[0] ? field.files[0] : null;
        input[key] = null;
        if (file) uploads.push({ key: key, file: file });
        return;
      }

      if (BOOLEAN_FIELDS.indexOf(key) !== -1) {
        input[key] = !!field.checked;
        return;
      }

      var value = (field.value || '').trim();
      input[key] = value || null;
    });

    if (input.purchase_location !== 'Other') {
      input.purchase_location_other = null;
    }

    return { input: input, uploads: uploads };
  }

  async function submitRegistration(endpoint, token, input, uploads) {
    var map = {};
    var formData = new FormData();

    uploads.forEach(function (upload, index) {
      map[index] = ['variables.input.' + upload.key];
    });

    formData.append('operations', JSON.stringify({ query: MUTATION, variables: { input: input } }));
    formData.append('map', JSON.stringify(map));
    uploads.forEach(function (upload, index) {
      formData.append(String(index), upload.file);
    });

    var headers = {
      Accept: 'application/json',
      'apollo-require-preflight': 'true',
      'ngrok-skip-browser-warning': 'true'
    };
    if (token) headers.Authorization = 'Bearer ' + token;

    var response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: formData
    });

    var payload = await response.json().catch(function () { return null; });

    if (payload && Array.isArray(payload.errors) && payload.errors.length) {
      var message = payload.errors.map(extractGraphqlErrorMessage).filter(Boolean).join(' ');
      throw new Error(message || 'Your knife could not be registered. Please try again.');
    }

    if (!response.ok) {
      throw new Error((payload && payload.message) || 'Your knife could not be registered. Please try again.');
    }

    return payload && payload.data ? payload.data.createKnifeRegistration : null;
  }

  function init(root) {
    var form = root.querySelector('[data-rk-form]');
    if (!form || form.dataset.rkBound === 'true') return;
    form.dataset.rkBound = 'true';

    var formWrap = root.querySelector('[data-rk-form-wrap]');
    var confirmation = root.querySelector('[data-rk-confirmation]');
    var alertBox = root.querySelector('[data-rk-alert]');
    var submitButton = root.querySelector('[data-rk-submit]');
    var submitLabel = root.querySelector('[data-rk-submit-label]');
    var submitLabelDefault = submitLabel ? submitLabel.textContent : '';

    function hideAlert() {
      if (!alertBox) return;
      alertBox.hidden = true;
      alertBox.textContent = '';
    }

    function showAlert(message) {
      if (!alertBox) return;
      alertBox.textContent = message;
      alertBox.hidden = false;
      alertBox.focus();
    }

    function setSubmitting(isSubmitting) {
      if (submitButton) submitButton.disabled = isSubmitting;
      if (submitLabel) submitLabel.textContent = isSubmitting ? 'Registering…' : submitLabelDefault;
    }

    function showConfirmation() {
      if (formWrap) formWrap.hidden = true;
      if (confirmation) {
        confirmation.hidden = false;
        confirmation.focus();
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideAlert();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var authConfig = (window.TKC && window.TKC.authConfig) || {};
      var endpoint = authConfig.endpoint;
      if (!endpoint) {
        showAlert('Registration is unavailable right now. Please try again later.');
        return;
      }

      var collected = collectInput(form);
      var token = getToken();

      setSubmitting(true);
      submitRegistration(endpoint, token, collected.input, collected.uploads)
        .then(function () {
          showConfirmation();
          form.reset();
        })
        .catch(function (error) {
          showAlert(error.message || 'Your knife could not be registered. Please try again.');
        })
        .finally(function () {
          setSubmitting(false);
        });
    });
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    document.querySelectorAll('.tkc-rk').forEach(init);
  });
})();
